import { Int } from '@adornis/baseql/baseqlTypes.js';
import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';
import { RatingsExportLine } from '@ils/export/db/ratings-export.js';
import { getRatingsExportLinesByFilterResolver } from '@ils/export/server/ratings-export.js';

export const getRatingExportLinesByFilter = registerSubscription({
  operationName: 'getRatingExportLinesByFilter',
  type: () => [RatingsExportLine],
  resolve: getRatingsExportLinesByFilterResolver,
  params: [
    { name: 'skip', type: () => Int },
    { name: 'limit', type: () => Int },
    { name: 'filter', type: () => AdornisFilter },
  ],
});
